import styled from 'styled-components';

export const InvestmentPlaceholderStyles = styled.div`
	.icon-container {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 38px;
		height: 38px;
		border-radius: 50%;
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}
`;
